import BackBottonStyled from "@Components/Commons/BackBotton/BackBotton.styled"
import { useHistory } from "react-router-dom"
import { IconArrowLeft } from "@Theme/common/Icon.styled"

const BackBotton: React.FC = ({ children }) => {
  const history = useHistory()

  const handleClicGoBack = () => history.goBack()

  return (
    <BackBottonStyled>
      <div className="icon-go-to-back" onClick={handleClicGoBack}>
        <IconArrowLeft />
      </div>
      {children}
    </BackBottonStyled>
  )
}

export default BackBotton
